import css from './transaction-detail.module.scss';
import {Header} from '../../components/header/header';
import {TRANSACTION_DETAIL} from './transaction-detail.mock';
import {useNavigate} from '@tanstack/react-location';

export const TransactionDetail = (): JSX.Element => {
	const navigate = useNavigate();

	const onBack = () => {
		navigate({to: '/wallet'});
	};

	const txDetail = TRANSACTION_DETAIL.map(({label, text}) => {
		return (
			<div key={label} className={css.row}>
				<span>{label}</span>
				<div className={css.txAddress}>
					<span>{text}</span>
					<img className={css.copyIcon} height={22} src="/img/copyIconGray.svg" />
				</div>
			</div>
		);
	});
	return (
		<div>
			<Header onBack={onBack} title="Transaction Details" />
			<div className={css.body}>
				<div className={`${css.row} ${css.amountTransferred}`}>
					<span>AMOUNT TRANSFERRED</span>
					<span>2,000 SET</span>
				</div>
				{txDetail}
				<div className={css.row}>
					<span>DATE</span>
					<span>3 April 2022 · 14:39:23</span>
				</div>
				<div className={css.row}>
					<span>FEE</span>
					<span>3 SET</span>
				</div>
			</div>
		</div>
	);
};
